import type { SxProps, Theme } from '@mui/material';

export const ToastifyMessageCloseButtonStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'start',
  cursor: 'pointer',
  marginLeft: 'auto',
};
